import List from "@/components/list";
import router from "@/router";
// import vue from "@/main";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};

  // 查看调查人员
  function enrollUserList(enroll) {
    router.push({
      path: "enrollment/users",
      query: {
        id: enroll.uuid,
        isAttachment: enroll.isAttachment,
        status: enroll.classStatus,
        isOnline: enroll.isOnline,
        onlineLearn: enroll.trainType == 24 && enroll.isRelevanceZwy == 1 ? 1 : 0
      }
    });
  }

  // 请假管理页
  function goLeaveManage(enroll) {
    router.push({
      path: "enrollment/leaveManage",
      query: {
        classId: enroll.uuid,
        className: enroll.className
      }
    });
  }

  // 教学管理-教学计划
  function teachingPlan(enroll) {
    router.push({
      path: "offlineClass/teaching",
      query: { id: enroll.uuid, classStatus: enroll.classStatus, className: enroll.className },
    });
  }

  const Deal = ({ props: { vo } }) => {
    const enroll = vo.row;

    return (
      <div class="deal-group">
        <el-tooltip
          content="学员管理"
          placement="top"
          v-permission="enroll:pageEnroll"
        >
          <i
            class="user-enroll-icon"
            onClick={() => enrollUserList(enroll)}
          ></i>
        </el-tooltip>

        {enroll.isOnline == 0 ? (
          <el-tooltip
            content="请假管理"
            placement="top"
            v-permission="enrollment:leaveManage"
          >
            <i
              class="iconfont ic_leavemanagement iconfont-adapt"
              onClick={() => goLeaveManage(enroll)}
            ></i>
          </el-tooltip>
        ) : null}
        {enroll.hasTeachButton == 1 ? (
          <el-tooltip content="教学管理" placement="top">
          <i
            class="icon-teaching"
            onClick={() => teachingPlan(enroll)}
          ></i>
        </el-tooltip>
        ) : null}
      </div>
    );
  };

  const ClassStatusName = ({ props: { vo } }) => {
    const classStatusName = vo.row.classStatusName
      ? vo.row.classStatusName
      : "--";
    return <span>{classStatusName}</span>;
  };
  const EnrollTime = ({ props: { vo, type } }) => {
    let enrollTime = ""
    if (type == 1) {
      enrollTime = vo.row.trainStartTime + "～" + vo.row.trainEndTime;
    } else {
      if (vo.row.enrollStartTime && vo.row.enrollEndTime) {
        enrollTime = vo.row.enrollStartTime + "～" + vo.row.enrollEndTime;
      } else {
        enrollTime = "--";
      }
    }
    
    return <span>{enrollTime}</span>;
  };
  const AccountTableConfig = [
    {
      label: "班级名称",
      minWidth: "200",
      render: (vo) => (
        <div class="base-hover-char"
          onClick={() => {
            if (vo.row.isOnline == 1) {
              router.push({
                path: "/onlineClass/detail",
                query: { id: vo.row.uuid },
              });
            } else {
              router.push({
                path: "/offlineClass/detail",
                query: { id: vo.row.uuid },
              });
            }
          }}
        >
          {vo.row.className}
        </div>
      ),
    },
    {
      label: "主办单位",
      prop: "organizer",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "培训类型",
      width: "130",
      prop: "trainTypeName"
    },
    {
      label: "报名情况",
      prop: "enrollSituation",
      width: "110",
      showOverflowTooltip: true,
      renderHeader: () => {
        return (
          <div class="table-row-column">
            <span>报名情况</span>
            <span>报名|计划(人)</span>
          </div>
        )
      }
    },
    {
      label: "班级状态",
      prop: "classStatusName",
      width: "100",
      render: vo => <ClassStatusName vo={vo} />
    },
    {
      label: "报名时间",
      width: "190",
      render: vo => <EnrollTime vo={vo} type={0}/>
    },
    {
      label: "培训时间",
      width: "190",
      render: vo => <EnrollTime vo={vo} type={1} />
    },
    {
      label: "操作",
      fixed: "right",
      width: "100",
      align: "center",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
